import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADNTAuthStore entity - alias of ADObject
 * Represents Active Directory NT Auth Store objects
 */
export const adNTAuthStoreEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADNTAuthStore', display: 'AD NT Auth Store' },
  alias: 'ADObject',
};
